import { render, staticRenderFns } from "./LinhaTabelaDetalhesProdutos.vue?vue&type=template&id=7cb895d8&scoped=true"
import script from "./LinhaTabelaDetalhesProdutos.vue?vue&type=script&lang=js"
export * from "./LinhaTabelaDetalhesProdutos.vue?vue&type=script&lang=js"
import style0 from "./LinhaTabelaDetalhesProdutos.vue?vue&type=style&index=0&id=7cb895d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb895d8",
  null
  
)

export default component.exports